import httpClient from '../api/httpClient'

export const getReports = async (payload) => {
  const endpoint = '/RefReports/Search?status=' + payload
  return httpClient.get(endpoint, payload)
}

export const reportEntity = async (payload) => {
  const endpoint = '/RefReports/Create'
  return httpClient.post(endpoint, payload)
}

export const getReportInfo = async (payload) => {
  const endpoint = '/RefReports?EntityId=' + payload
  return httpClient.get(endpoint, payload)
}

export const resolveReport = async (payload) => {
  const endpoint = '/RefReports/update'
  return httpClient.put(endpoint, payload)
}

export default {
  getReports,
  reportEntity,
  getReportInfo,
  resolveReport
}
